import React, { useEffect, useState } from 'react'
import { social_api_base_url, web_base_url, cognito_app_client_id } from "../../config/config";
import path from "../../routes/path";
import { useTranslation } from 'react-i18next';
import './static/SocialLogin.scss'
import gmail from '../../assets/image/gmail.svg';
const qs = require('query-string');

const SocialLogin = () => {
    const { t } = useTranslation();
    const { search } = window?.location;
    const queryParams = qs.parse(search);
    const parsed = qs.parse(window.location.search);

    const [Loading, setLoading] = useState(false);
    const [Provider, setProvider] = useState('');

    useEffect(() => {
        setLoading(false);
        window.onunload = () => {
            setTimeout(() => {
                setLoading((false))
            }, 3000);
        }
    }, []);


    const socialLoginRedirect = (provider) => {
        setLoading(true)
        setProvider(provider)
        if (queryParams.sessionRedirect) {
            sessionStorage.setItem('sessionRedirect', JSON.stringify({ url: queryParams.sessionRedirect, pass: queryParams.password, isLiveSession: queryParams.isLiveSession }));
        }
        window.location.href =
            social_api_base_url +
            `/oauth2/authorize?identity_provider=` +
            provider +
            `&redirect_uri=` +
            web_base_url +
            path.social_redirect_url +
            `/&response_type=CODE&client_id=` +
            cognito_app_client_id +
            `&scope=aws.cognito.signin.user.admin profile email openid`;
    };

    return (
        <>
            <div className="social-login-icon">
                <div className="or-divider">
                    <div className="or-divider-line"></div>
                    <div className="or-divider-text">{t('auth_page.or')}</div>
                    <div className="or-divider-line"></div>
                </div>
                <ul>
                    <li className="google">
                        <button
                            id="social-login-google-btn"
                            className="btn-gmail w-100" disabled={Loading}
                            onClick={() => socialLoginRedirect("Google")}
                        >
                            {/* {
                        (loading && Provider === "Google") ? <Icon width={'24px'} height={'24px'} icon={'eos-icons:loading'} className="me-1"/> :
                            <Image src={gmail} alt=""/>
                    } */}
                            <img src={gmail} alt="" />
                            <span>{t('auth_page.login_with_google')}</span>

                        </button>
                    </li>
                    {/* <li className="facebook">
                        <a
                        // disabled={Loading}
                        onClick={() => socialLoginRedirect("Facebook")}
                        >
                            {
                            (Loading && Provider === <i className="fab fa-facebook-f"></i> ) ? <i class="fa-solid fa-spinner fa-spin"></i> :
                            <i className="fab fa-facebook-f"></i> 
                            }
                            
                            <span>{t('auth_page.facebook')}</span>
                        </a>
                    </li>
                    <li className="linkedin">
                        <a
                        // disabled={Loading}
                        onClick={() => {
                            socialLoginRedirect("Auth0")
                            localStorage.setItem("socialProvider", "AUTH0")
                        }}
                        >
                        {
                            (Loading && Provider === <i className="fab fa-linkedin"></i> ) ? <i class="fa-solid fa-spinner fa-spin"></i> :
                            <i className="fab fa-linkedin"></i> 
                        }
                            
                            <span>{t('auth_page.linkedin')}</span>
                        </a>
                    </li> */}
                </ul>
            </div>
        </>
    )
}

export default SocialLogin;
